YOBONKE<template>
    <div class="intro-box">
        <div class="card-list-box">
            <div class="item-card">
                <div class="title">YOBONKE电话助手单控手机演示
                </div>
                <div class="img-box"><img src="@/assets/image/intro/intro1.png" alt=""></div>
            </div>
            <div class="item-card">
                <div class="title">YOBONKE群控手机自动拨号演示

                </div>
                <div class="img-box"><img src="@/assets/image/intro/intro2.png" alt=""></div>
            </div>
            <div class="item-card">
                <div class="title">YOBONKE管理员分配资源给员工
                </div>
                <div class="img-box"><img src="@/assets/image/intro/intro3.png" alt=""></div>
            </div>

        </div>

    </div>
</template>

<script>


export default {

}
</script>

<style lang="less" scoped>
.card-list-box {
    .item-card {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-bottom: 20px;

        .title {
            color: #747577;
            font-size: 30px;
            margin-bottom: 20px;
        }

        .img-box {
            width: 983px;
            height: 526px;

            img {
                width: 100%;
                height: 100%;
            }
        }
    }
}
</style>
